import { useMutation, useQueryClient } from "@tanstack/react-query";
import { duplicateMatrix, matrixQueries } from "@/domains/matrix";

type DuplicateMatrixParams = { collectionId: string; name?: string };

export function useDuplicateMatrix() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ collectionId, name }: DuplicateMatrixParams) =>
      duplicateMatrix(collectionId, name),
    onSuccess: () => queryClient.invalidateQueries(matrixQueries.lists()),
  });
}
